import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { hasModuleAccess, rolesConfig } from "../config/rolesConfig";

const RoleRoute = ({ moduleName }) => {
  let userRole = null;
  try {
    const session = sessionStorage.getItem("aman-admin");
    if (session) {
      const parsedSession = JSON.parse(session);
      const admin = JSON.parse(parsedSession?.admin || "{}");
      userRole = admin?.role;
    }
  } catch (e) {
    userRole = null;
  }

  // If no role or no moduleName specified, allow Outlet or fallback
  if (!userRole) {
    return <Outlet />;
  }

  if (moduleName) {
    const allowed = hasModuleAccess(userRole, moduleName);
    if (!allowed) {
      // Find first accessible module for this user's role to redirect to
      const userModules = rolesConfig[userRole]?.modules || [];
      const firstModule = userModules.find((mod) => mod !== "dashboard") || "customer";
      return <Navigate to={`/dashboard/${firstModule}`} replace />;
    }
  }

  return <Outlet />;
};

export default RoleRoute;
